/**
 * Layering for AWS (Location) address suggestion lists so they appear above the sticky
 * Continue footer and keyboard-adjacent UI. Keep below modal/header overlays (e.g. zIndex 10+).
 */
export const ADDRESS_AUTOCOMPLETE_DROPDOWN_Z_INDEX = 10050;

/** Scroll/content area while on address autocomplete steps — above sticky footer (zIndex 1). */
export const ADDRESS_STEP_SCROLL_Z_INDEX = 100;

/** Sticky Continue/footer bar — below open address dropdown stack. */
export const STICKY_FOOTER_UNDER_ADDRESS_OVERLAY_Z_INDEX = 1;
